<template>
  <div class="common-search-input">
    <img
      class="search-img"
      @click="$emit('search')"
      src="../../../../assets/imgs/work-wx/common/icon-search.svg"
    />
    <input
      class="search-input"
      v-model="innerSearchText"
      :maxlength="maxlength"
      v-on:keydown.enter="$emit('search')"
      type="search"
      :placeholder="placeholder"
    />
    <img
      class="delete-search"
      v-show="innerSearchText"
      @click="clearSearch"
      src="../../../../assets/imgs/work-wx/customer/btn-delete-text.svg"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    placeholder: String,
    maxlength: Number,
  },
  data() {
    return {
      searchText: '',
    };
  },
  computed: {
    innerSearchText: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val ? val.trim() : undefined);
      },
    },
  },
  methods: {
    clearSearch() {
      this.innerSearchText = '';
      this.$emit('search');
    },
  },
};
</script>

<style lang="less" scoped>
.common-search-input {
  display: flex;
  align-items: center;
  background: #f0f2f7;
  border-radius: 14px;
  padding: 0 10px;
  width: 160px;
  height: 30px;
  .search-img {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .search-input {
    width: 125px;
    outline: none;
    border: none;
    background-color: transparent;
    font-size: 14px;
    color: #2c3344;
    line-height: 20px;
    padding: 0;
    margin: 0;
    -webkit-appearance: none;
    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }
  }
  .delete-search {
    cursor: pointer;
    width: 12px;
    height: 12px;
  }
  ::-webkit-input-placeholder {
    color: #717785;
  }
  :-moz-placeholder {
    color: #717785;
  }
  ::-moz-placeholder {
    color: #717785;
  }
  :-ms-input-placeholder {
    color: #717785;
  }
}
</style>
